module.exports = __webpack_public_path__ + "img/icon-payment-cards.e3087422.png";